export const locale = {
    lang: 'tr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Programlar',
            'SAMPLE'        : {
                'TITLE': 'Örnek',
                'BADGE': '15'
            }
        }
    }
};



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/navigation/i18n/tr.ts